import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SellComponent } from './sell.component';
import { PlateXValBandComponent } from './components/plate-x-val-band/plate-x-val-band.component';
import { PlateXPulseRailComponent } from './components/plate-x-pulse-rail/plate-x-pulse-rail.component';
import { PlateXFlowComponent } from './components/plate-x-flow/plate-x-flow.component';
import { PlateXBranchCardComponent } from './components/plate-x-branch-card/plate-x-branch-card.component';
import { PlateXLiveMarketComponent } from './components/plate-x-live-market/plate-x-live-market.component';
import { PlateXLiquidityCardComponent } from './components/plate-x-liquidity-card/plate-x-liquidity-card.component';
import { PlateXScenarioCardComponent } from './components/plate-x-scenario-card/plate-x-scenario-card.component';
import { PlateXFaqComponent } from './components/plate-x-faq/plate-x-faq.component';

@NgModule({
  declarations: [
    SellComponent,
    PlateXValBandComponent,
    PlateXPulseRailComponent,
    PlateXFlowComponent,
    PlateXBranchCardComponent,
    PlateXLiveMarketComponent,
    PlateXLiquidityCardComponent,
    PlateXScenarioCardComponent,
    PlateXFaqComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
  ],
  exports: [
    PlateXValBandComponent,
    PlateXPulseRailComponent,
    PlateXFaqComponent,
  ],
})
export class SellModule {}
